import React from 'react'
import { BtCurrencyInput } from '@linqpal/components/src/ui'
import { useTranslation } from 'react-i18next'

const ContractValue = ({ model, value }) => {
  const { t } = useTranslation('global')
  const handleChange = (val) => {
    model.setValue(val)
  }
  return (
    <BtCurrencyInput
      size="large"
      label={t('ProjectForm.contract-value-label')}
      value={value}
      maxLength={15}
      onChangeText={handleChange}
      testID={'projectInfo_contractValue'}
      placeholder="$"
    />
  )
}

export default {
  identifier: 'contractValue',
  title: '',
  component: ContractValue,
  shouldProcessAnswer: true,
  optional: true,
}
